"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CardChoiceSchema = void 0;
// src/dto/CardChoiceDTO.ts
const zod_1 = require("zod");
const CardDTO_1 = require("./CardDTO");
const CardChoiceSchema = zod_1.z.object({
    isSelected: zod_1.z.boolean(),
    isAnswereCorrect: zod_1.z.boolean(),
    card: CardDTO_1.CardSchema,
});
exports.CardChoiceSchema = CardChoiceSchema;
